// MSG/platform version ของ useLocationState (ishealth-main)
//
// ตัวจริงของ main app อ่านข้อมูลจาก router state (location.state) ของ
// AppointmentInfo page — ใน platform (MSG) ไม่มี route แบบนั้น
//
// ปัจจุบัน BookingSection ส่งข้อมูลเป็น prop (locationState) ตรง ๆ แล้ว
// เก็บ file นี้ไว้เป็น fallback ของ component ที่ port มาจาก main
// (CardAddressInfo ยังอ่าน shared state เมื่อ caller ไม่ได้ส่ง prop มา)

type LocationState = Record<string, any>;

let sharedState: LocationState = {};

export const setLocationState = (state: LocationState) => {
  sharedState = state || {};
};

// อ่านค่าปัจจุบันของ module var ในแต่ละ render (component ที่อ่านต้อง render AFTER
// component ที่เรียก setLocationState — ใน MSG คือ BookingSection → Card*)
const useLocationState = <T extends LocationState = LocationState>() =>
  sharedState as T;

export default useLocationState;
